<div class="contacts-container mt-4">
        <div class="d-grid contacts-header">
            <div class="d-flex align-items-center contact-title-wrapper">
                <img src="assets/svg/folder-icon.svg" width="20" class="contact-section-icon">
                <h3 class="text-semibold contact-title">Archivos ({{uploadedFiles.length}})</h3>
            </div>
            <div class="justify-self-end">
                <label for="file-upload" class="action-btn primary d-flex align-items-center cursor-pointer mb-0">
                    <img src="assets/svg/upload-arrow-icon.svg" width="20" class="me-2">
                    Subir archivos
                </label>
                <input 
                    id="file-upload" 
                    type="file" 
                    multiple 
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif" 
                    (change)="onFileSelected($event)"
                    style="display: none;"
                >
            </div>
        </div>
        <div class="contacts-body mt-3" style="max-height: 25vh; overflow-y: auto;">
            <div *ngIf="uploadedFiles.length > 0" class="uploaded-files mt-3">
                <div *ngFor="let file of uploadedFiles" class="file-item d-flex align-items-center mb-2">
                    <img src="assets/svg/folder-icon.svg" width="16" class="me-2">
                    <a [href]="file.url" target="_blank" class="file-link">{{ file.nombre }}</a>
                 <button class="btn-delete" (click)="onDeleteFile(file)">
                    <img src="assets/svg/close-icon.svg" width="16">
                </button>

                </div>
            </div>
        </div>
    </div>